var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "section",
        { staticClass: "section", attrs: { id: "tarjouksen-tiedot" } },
        [
          _c("h2", { staticClass: "section__heading section__heading--alt2" }, [
            _vm._v("\n      Tarjouksen tiedot\n    ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "checkout__rows" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "checkout__subsection" }, [
              _c("div", { staticClass: "field field--long" }, [
                _c("label", { attrs: { for: "customer_reference" } }, [
                  _vm._v("\n            Asiakkaan viite\n          ")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newOfferDetails.customer_reference,
                      expression: "newOfferDetails.customer_reference"
                    }
                  ],
                  attrs: {
                    id: "customer_reference",
                    type: "text",
                    name: "customer_reference",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.newOfferDetails.customer_reference },
                  on: {
                    change: function($event) {
                      return _vm.fieldChanged()
                    },
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.newOfferDetails,
                        "customer_reference",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--clear field--short" }, [
                _c("label", { attrs: { for: "offer_date" } }, [
                  _vm._v("\n            Jättöpäivä\n          ")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "datepicker datepicker-trigger" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newOfferDetails.offer_date,
                          expression: "newOfferDetails.offer_date"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "date_format:DD.MM.YYYY",
                          expression: "'date_format:DD.MM.YYYY'"
                        }
                      ],
                      attrs: {
                        id: "offer_date",
                        type: "text",
                        name: "offer_date",
                        disabled: !_vm.$store.getters.changesAllowed
                      },
                      domProps: { value: _vm.newOfferDetails.offer_date },
                      on: {
                        change: function($event) {
                          return _vm.fieldChanged()
                        },
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.newOfferDetails,
                            "offer_date",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("AirbnbStyleDatepicker", {
                      attrs: {
                        "trigger-element-id": "offer_date",
                        mode: "single",
                        "months-to-show": 1,
                        "fullscreen-mobile": false,
                        "date-one": _vm.datepickerOfferDate
                      },
                      on: { "date-one-selected": _vm.selectOfferDate }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.errors.has("offer_date")
                  ? _c("span", { staticClass: "form-field-error-message" }, [
                      _vm._v(_vm._s(_vm.errors.first("offer_date")))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--clear" }, [
                _c("label", { attrs: { for: "offer_terms" } }, [
                  _vm._v("\n            Toimitusehto\n          ")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newOfferDetails.offer_terms,
                      expression: "newOfferDetails.offer_terms"
                    }
                  ],
                  attrs: {
                    id: "offer_terms",
                    type: "text",
                    name: "offer_terms",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.newOfferDetails.offer_terms },
                  on: {
                    change: function($event) {
                      return _vm.fieldChanged()
                    },
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.newOfferDetails,
                        "offer_terms",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--clear" }, [
                _c("label", { attrs: { for: "offer_delivery" } }, [
                  _vm._v("\n            Kuljetus\n          ")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newOfferDetails.offer_delivery,
                      expression: "newOfferDetails.offer_delivery"
                    }
                  ],
                  attrs: {
                    id: "offer_delivery",
                    type: "text",
                    name: "offer_delivery",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.newOfferDetails.offer_delivery },
                  on: {
                    change: function($event) {
                      return _vm.fieldChanged()
                    },
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.newOfferDetails,
                        "offer_delivery",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--float" }, [
                _c("label", { attrs: { for: "offer_installation" } }, [
                  _vm._v("\n            Asennus\n          ")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newOfferDetails.offer_installation,
                      expression: "newOfferDetails.offer_installation"
                    }
                  ],
                  attrs: {
                    id: "offer_installation",
                    type: "text",
                    name: "offer_installation",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.newOfferDetails.offer_installation },
                  on: {
                    change: function($event) {
                      return _vm.fieldChanged()
                    },
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.newOfferDetails,
                        "offer_installation",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--no-label" }, [
                _c("label", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newOfferDetails.offer_installation_actual,
                        expression: "newOfferDetails.offer_installation_actual"
                      }
                    ],
                    staticClass: "checkbox-input",
                    attrs: {
                      id: "offer_installation_actual",
                      type: "checkbox",
                      name: "offer_installation_actual",
                      disabled: !_vm.$store.getters.changesAllowed
                    },
                    domProps: {
                      checked: Array.isArray(
                        _vm.newOfferDetails.offer_installation_actual
                      )
                        ? _vm._i(
                            _vm.newOfferDetails.offer_installation_actual,
                            null
                          ) > -1
                        : _vm.newOfferDetails.offer_installation_actual
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a =
                              _vm.newOfferDetails.offer_installation_actual,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.newOfferDetails,
                                  "offer_installation_actual",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.newOfferDetails,
                                  "offer_installation_actual",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(
                              _vm.newOfferDetails,
                              "offer_installation_actual",
                              $$c
                            )
                          }
                        },
                        function($event) {
                          return _vm.fieldChanged()
                        }
                      ],
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass:
                        "checkbox-label checkbox-label--small checkbox-label--high"
                    },
                    [_vm._v("Veloitetaan toteutuneen mukaan")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--clear" }, [
                _c("label", { attrs: { for: "offer_delivery" } }, [
                  _vm._v("\n            Kierrätys\n          ")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newOfferDetails.offer_recycling,
                      expression: "newOfferDetails.offer_recycling"
                    }
                  ],
                  attrs: {
                    id: "offer_recycling",
                    type: "text",
                    name: "offer_recycling",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.newOfferDetails.offer_recycling },
                  on: {
                    change: function($event) {
                      return _vm.fieldChanged()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.newOfferDetails,
                        "offer_recycling",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--clear" }, [
                _c("label", { attrs: { for: "offer_delivery_time" } }, [
                  _vm._v("\n            Toimitusaika\n          ")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newOfferDetails.offer_delivery_time,
                      expression: "newOfferDetails.offer_delivery_time"
                    }
                  ],
                  attrs: {
                    id: "offer_delivery_time",
                    type: "text",
                    name: "offer_delivery_time",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.newOfferDetails.offer_delivery_time },
                  on: {
                    change: function($event) {
                      return _vm.fieldChanged()
                    },
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.newOfferDetails,
                        "offer_delivery_time",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--clear" }, [
                _c("label", { attrs: { for: "offer_payment_terms" } }, [
                  _vm._v("\n            Maksuehto\n          ")
                ]),
                _vm._v(" "),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newOfferDetails.offer_payment_terms,
                      expression: "newOfferDetails.offer_payment_terms"
                    }
                  ],
                  attrs: {
                    id: "offer_payment_terms",
                    name: "offer_payment_terms",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.newOfferDetails.offer_payment_terms },
                  on: {
                    change: function($event) {
                      return _vm.fieldChanged()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.newOfferDetails,
                        "offer_payment_terms",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--float field--short" }, [
                _c("label", { attrs: { for: "offer_expiry" } }, [
                  _vm._v("\n            Voimassaoloaika\n          ")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "datepicker datepicker-trigger" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newOfferDetails.offer_expiry,
                          expression: "newOfferDetails.offer_expiry"
                        },
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "date_format:DD.MM.YYYY",
                          expression: "'date_format:DD.MM.YYYY'"
                        }
                      ],
                      attrs: {
                        id: "offer_expiry",
                        type: "text",
                        name: "offer_expiry",
                        disabled: !_vm.$store.getters.changesAllowed
                      },
                      domProps: { value: _vm.newOfferDetails.offer_expiry },
                      on: {
                        change: function($event) {
                          return _vm.fieldChanged()
                        },
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.newOfferDetails,
                            "offer_expiry",
                            $event.target.value
                          )
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("AirbnbStyleDatepicker", {
                      attrs: {
                        "trigger-element-id": "offer_expiry",
                        mode: "single",
                        "months-to-show": 1,
                        "fullscreen-mobile": false,
                        "date-one": _vm.datepickerOfferExpiry
                      },
                      on: { "date-one-selected": _vm.selectOfferExpiry }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.errors.has("offer_expiry")
                  ? _c("span", { staticClass: "form-field-error-message" }, [
                      _vm._v(_vm._s(_vm.errors.first("offer_expiry")))
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--clear" }, [
                _c("label", { attrs: { for: "offer_guarantee" } }, [
                  _vm._v("\n            Takuu\n          ")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newOfferDetails.offer_guarantee,
                      expression: "newOfferDetails.offer_guarantee"
                    }
                  ],
                  attrs: {
                    id: "offer_guarantee",
                    type: "text",
                    name: "offer_guarantee",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.newOfferDetails.offer_guarantee },
                  on: {
                    change: function($event) {
                      return _vm.fieldChanged()
                    },
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.newOfferDetails,
                        "offer_guarantee",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--long field--clear" }, [
                _c("label", { attrs: { for: "offer_price_heading" } }, [
                  _vm._v("\n            Hinnan otsikko\n          ")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newOfferDetails.offer_price_heading,
                      expression: "newOfferDetails.offer_price_heading"
                    }
                  ],
                  attrs: {
                    id: "offer_price_heading",
                    type: "text",
                    name: "offer_price_heading",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.newOfferDetails.offer_price_heading },
                  on: {
                    change: function($event) {
                      return _vm.fieldChanged()
                    },
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.newOfferDetails,
                        "offer_price_heading",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--long field--clear" }, [
                _c("label", { staticClass: "checkbox" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.newOfferDetails.show_total,
                        expression: "newOfferDetails.show_total"
                      }
                    ],
                    staticClass: "checkbox-input",
                    attrs: {
                      id: "show_total",
                      type: "checkbox",
                      name: "show_total",
                      disabled: !_vm.$store.getters.changesAllowed
                    },
                    domProps: {
                      checked: Array.isArray(_vm.newOfferDetails.show_total)
                        ? _vm._i(_vm.newOfferDetails.show_total, null) > -1
                        : _vm.newOfferDetails.show_total
                    },
                    on: {
                      change: [
                        function($event) {
                          var $$a = _vm.newOfferDetails.show_total,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.newOfferDetails,
                                  "show_total",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.newOfferDetails,
                                  "show_total",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.newOfferDetails, "show_total", $$c)
                          }
                        },
                        function($event) {
                          return _vm.fieldChanged()
                        }
                      ],
                      keydown: function($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        $event.preventDefault()
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "checkbox-label checkbox-label--last" },
                    [_vm._v("Näytä yhteishinta tarjouksen toisella sivulla")]
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "checkout__header" }, [
              _c("div", { staticClass: "cart__search" }, [
                _vm._m(1),
                _vm._v(" "),
                _vm.currentUserHasManagerRole
                  ? _c(
                      "div",
                      { staticClass: "cart__search__input-container" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "select cart__search__input cart__search__input--with-icon"
                          },
                          [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.selectedSalesPerson,
                                    expression: "selectedSalesPerson"
                                  }
                                ],
                                attrs: { id: "salesperson" },
                                on: {
                                  change: [
                                    function($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.selectedSalesPerson = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    },
                                    function($event) {
                                      return _vm.fieldChanged()
                                    }
                                  ],
                                  keydown: function($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                  }
                                }
                              },
                              [
                                _c("option", { domProps: { value: null } }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$modeoL10n.select) +
                                      "\n                "
                                  )
                                ]),
                                _vm._v(" "),
                                _vm._l(_vm.salesPersons, function(salesPerson) {
                                  return _c(
                                    "option",
                                    {
                                      key: salesPerson.id,
                                      domProps: { value: salesPerson }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(salesPerson.first_name) +
                                          " " +
                                          _vm._s(salesPerson.last_name) +
                                          " (" +
                                          _vm._s(salesPerson.code) +
                                          ")\n                "
                                      )
                                    ]
                                  )
                                })
                              ],
                              2
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "checkout__subsection" }, [
              _vm.selectedSalesPerson
                ? _c(
                    "p",
                    [
                      _vm.selectedSalesPerson.first_name ||
                      _vm.selectedSalesPerson.last_name
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.selectedSalesPerson.first_name) +
                                " " +
                                _vm._s(_vm.selectedSalesPerson.last_name)
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedSalesPerson.title
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.selectedSalesPerson.title)
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedSalesPerson.email
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.selectedSalesPerson.email)
                            ),
                            _c("br")
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedSalesPerson.phone
                        ? [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.selectedSalesPerson.phone) +
                                "\n          "
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                : _c("div", { staticClass: "checkout__subsection__empty" }, [
                    _vm._v("\n          Ei valittua myyjää\n        ")
                  ])
            ]),
            _vm._v(" "),
            _vm._m(2),
            _vm._v(" "),
            _c("div", { staticClass: "checkout__subsection" }, [
              _c("label", { staticClass: "checkbox" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newOfferDetails.attachments_terms,
                      expression: "newOfferDetails.attachments_terms"
                    }
                  ],
                  staticClass: "checkbox-input",
                  attrs: {
                    id: "attachments_terms",
                    type: "checkbox",
                    name: "attachments_terms",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: {
                    checked: Array.isArray(
                      _vm.newOfferDetails.attachments_terms
                    )
                      ? _vm._i(_vm.newOfferDetails.attachments_terms, null) > -1
                      : _vm.newOfferDetails.attachments_terms
                  },
                  on: {
                    change: [
                      function($event) {
                        var $$a = _vm.newOfferDetails.attachments_terms,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.newOfferDetails,
                                "attachments_terms",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.newOfferDetails,
                                "attachments_terms",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(
                            _vm.newOfferDetails,
                            "attachments_terms",
                            $$c
                          )
                        }
                      },
                      function($event) {
                        return _vm.fieldChanged()
                      }
                    ],
                    keydown: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      $event.preventDefault()
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "checkbox-label checkbox-label--last" },
                  [_vm._v("Sopimusehdot")]
                )
              ])
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("section", { staticClass: "section" }, [
        _c("div", { staticClass: "checkout__rows" }, [
          _c("div", { staticClass: "grid-wrap" }, [
            _c(
              "div",
              { staticClass: "grid-col grid-col-right bp2-col-one-half" },
              [
                _c("div", { staticClass: "checkout__offer-status select" }, [
                  _c("span", {
                    staticClass: "checkout__offer-status__detail",
                    class:
                      "checkout__offer-status__detail--" +
                      _vm.newOfferDetails.status
                  }),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.newOfferDetails.status,
                          expression: "newOfferDetails.status"
                        }
                      ],
                      attrs: { disabled: !_vm.$store.getters.changesAllowed },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.newOfferDetails,
                              "status",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function($event) {
                            return _vm.fieldChanged()
                          }
                        ],
                        keydown: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { value: "offer-draft" } }, [
                        _vm._v("\n                Luonnos\n              ")
                      ]),
                      _vm._v(" "),
                      _c("option", { attrs: { value: "offer" } }, [
                        _vm._v("\n                Valmis\n              ")
                      ])
                    ]
                  )
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "grid-wrap" }, [
            _vm._m(3),
            _vm._v(" "),
            _vm.$store.getters.changesAllowed
              ? _c(
                  "div",
                  {
                    staticClass:
                      "checkout__delete-offer-container grid-col bp2-col-one-half"
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "checkout__delete-offer",
                        attrs: { type: "submit" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.confirmOfferDelete()
                          }
                        }
                      },
                      [_vm._v("\n            Poista tarjous\n          ")]
                    )
                  ]
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("delete-offer-modal", {
        attrs: {
          "offer-id": _vm.offerId,
          display: _vm.displayModal,
          nonce: _vm.nonce
        },
        on: {
          cancel: function($event) {
            _vm.displayModal = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checkout__header" }, [
      _c("h3", { staticClass: "checkout__header__heading" }, [
        _vm._v("\n          Perustiedot\n        ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "cart__search__label", attrs: { for: "salesperson" } },
      [
        _c("h3", { staticClass: "checkout__header__heading" }, [
          _vm._v("Myyjä")
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "checkout__header" }, [
      _c("h3", { staticClass: "checkout__header__heading" }, [
        _vm._v("\n          Liitteet\n        ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "grid-col grid-col-right bp2-col-one-half" },
      [
        _c(
          "a",
          {
            staticClass: "checkout__button btn btn--secondary btn--block",
            attrs: { target: "_blank", href: "?format=pdf&show_prices=true" }
          },
          [_vm._v("Lataa tiedot PDF:nä")]
        )
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10e770ab", { render: render, staticRenderFns: staticRenderFns })
  }
}